export default "__VITE_ASSET__C_DC12Sx__"